import { contactFormTaxesMapper } from "features/Contactos/constants"

export default (contacto = {}) => ({
  // @ts-expect-error TS(2339): Property 'cuentaContableClienteId' does not exist ...
  cuentaContableClienteId: contacto.cuentaContableClienteId,
  // @ts-expect-error TS(2339): Property 'cuentaContableProveedorId' does not exis...
  cuentaContableProveedorId: contacto.cuentaContableProveedorId,
  // @ts-expect-error TS(2339): Property 'cuentaContableVentaId' does not exist on...
  cuentaContableVentaId: contacto.cuentaContableVentaId,
  // @ts-expect-error TS(2339): Property 'cuentaContableCompraId' does not exist o...
  cuentaContableCompraId: contacto.cuentaContableCompraId,
  ...contactFormTaxesMapper(contacto, [], true),
})
